
export const BinamikParser = {
  getFeeByPartners ({ data }) {
    return data
  }
}
